import request from '@/utils/request';
/* 列表 */
export function queryCouponPageList(data) {
  return request({
    url: '/coupon/queryCouponPageList',
    method: 'POST',
    data
  });
}
/* 增加 */
export function saveCoupon(data) {
  return request({
    url: '/coupon/saveCoupon',
    method: 'POST',
    data
  });
}
/* 修改 */
export function updateCoupon(data) {
  return request({
    url: '/coupon/updateCoupon',
    method: 'POST',
    data
  });
}
/* 修改中的信息展示 */
export function fetchCouponDetailById(data) {
  return request({
    url: '/coupon/fetchCouponDetailById',
    method: 'POST',
    data
  });
}
/* 删除 */
export function removeCouponById(data) {
  return request({
    url: '/coupon/removeCouponById',
    method: 'POST',
    data
  });
}
/* 商品分类信息列表 */
export function queryAllEnableGoodsCategoryList(data) {
  return request({
    url: '/coupon/business/queryAllEnableGoodsCategoryList',
    method: 'POST',
    data
  });
}
/* 商品信息列表 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/coupon/business/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 获取优惠券领取记录列表 */
export function queryCouponReceiveLogPageList(data) {
  return request({
    url: '/coupon/receive/log/queryCouponReceiveLogPageList',
    method: 'POST',
    data
  });
}
/* 获取小程序用户列表 */
export function queryMinAppUserPageList(data) {
  return request({
    url: '/coupon/receive/log/queryMinAppUserPageList',
    method: 'POST',
    data
  });
}
/* 系统手动发放优惠券 */
export function saveCouponReceiveLogBatch(data) {
  return request({
    url: '/coupon/receive/log/saveCouponReceiveLogBatch',
    method: 'POST',
    data
  });
}
/* 领券中心-活动列表 */
export function queryCouponActivityCenterPageList(data) {
  return request({
    url: '/coupon/activity/center/queryCouponActivityCenterPageList',
    method: 'POST',
    data
  });
}
/* 领券中心-删除 */
export function removeCouponActivityCenterById(data) {
  return request({
    url: '/coupon/activity/center/removeCouponActivityCenterById',
    method: 'POST',
    data
  });
}
/* 领券中心-新增 */
export function saveCouponActivityCenter(data) {
  return request({
    url: '/coupon/activity/center/saveCouponActivityCenter',
    method: 'POST',
    data
  });
}
/* 领券中心-修改 */
export function updateCouponActivityCenter(data) {
  return request({
    url: '/coupon/activity/center/updateCouponActivityCenter',
    method: 'POST',
    data
  });
}
/* 领券中心-活动明细 */
export function fetchCouponActivityCenterDetailById(data) {
  return request({
    url: '/coupon/activity/center/fetchCouponActivityCenterDetailById',
    method: 'POST',
    data
  });
}
/* 领券中心-小程序码 */
export function getCouponActivityQrCode(data) {
  return request({
    url: '/coupon/activity/center/getCouponActivityQrCode',
    method: 'POST',
    data
  });
}
/* 优惠券管理-列表 */
export function queryCouponManagementCenterPageList(data) {
  return request({
    url: '/coupon/management/center/queryCouponManagementCenterPageList',
    method: 'POST',
    data
  });
}
/* 优惠券管理-删除 */
export function removeCouponManagementCenterById(data) {
  return request({
    url: '/coupon/management/center/removeCouponManagementCenterById',
    method: 'POST',
    data
  });
}
/* 优惠券管理-新增 */
export function saveCouponManagementCenter(data) {
  return request({
    url: '/coupon/management/center/saveCouponManagementCenter',
    method: 'POST',
    data
  });
}
/* 优惠券管理-查询所有可用的优惠券信息列表 */
export function queryAllValidCouponList(data) {
  return request({
    url: '/coupon/queryAllValidCouponList',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/coupon.js